import { Table, Text } from '@factorialco/deprecated-design-system'

interface ExtraRowProps {
  columnOne?: string | null
  columnTwo?: string | null
  columnThree?: string | null
  columnFour?: string | null
  columnFive?: string | null
  extraEmptyColumns?: number
}

export const ExtraRow: React.FC<ExtraRowProps> = ({
  columnOne,
  columnTwo,
  columnThree,
  columnFour,
  columnFive,
  extraEmptyColumns = 0,
}) => {
  return (
    <Table.Row>
      <Table.Cell>
        <Text.Normal size="200" weight="normal" color="grey1000">
          {columnOne || ''}
        </Text.Normal>
      </Table.Cell>
      <Table.Cell>
        <Text.Normal size="200" weight="normal" color="grey1000">
          {columnTwo || ''}
        </Text.Normal>
      </Table.Cell>
      <Table.Cell>
        <Text.Normal size="200" weight="normal" color="grey1000">
          {columnThree || ''}
        </Text.Normal>
      </Table.Cell>
      <Table.Cell>
        <Text.Normal size="200" weight="medium">
          {columnFour || ''}
        </Text.Normal>
      </Table.Cell>
      <Table.Cell style={{ textAlign: 'right' }}>
        <Text.Normal size="200" weight="normal" color="grey1000">
          {columnFive || ''}
        </Text.Normal>
      </Table.Cell>
      {extraEmptyColumns > 0 && <Table.Cell colSpan={extraEmptyColumns} />}
    </Table.Row>
  )
}
